import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";

/*BootstrapTable anbd table Related*/
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

/*Other Components*/

/*Loader */

/*animation*/
/*Inputs*/
/*Styles*/
import "./PlayerStatistics.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));
export default function PlayerStatistics(props) {
  const classes = useStyles();
  const [gameRelatedOptions, setGameRelatedOptions] = React.useState([]);
  const [idSport, setIdSport] = React.useState(["CBB"]);
  const [playerStatistic, setPlayerStatistic] = React.useState([]);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [isLoading, setIsLoading] = React.useState(true);
  const [getStatistics, setNeedsToReload] = React.useState(props.needsToReload);
  let idPlayer = props.Player.idPlayer;
  console.log('props player ===>',props);

  let statsItems2 = [];
  const [statsItems, setStatsItems] = React.useState([]);
  // let IdPeriod = '0';
  useEffect(() => {
    getPlayerStatistics();
  }, [props.needsToReload]);
  // const [selectedIdGame, setselectedIdGame] = useState();

  const getPlayerStatistics = () => {
    const url =
      process.env.REACT_APP_API2_URL +
      "/Player/Player_GetStatistics?idPlayer=" +
      idPlayer;
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      setPlayerStatistic(response.data);

      for (let key in response.data) {
        statsItems.push(<li key={key}>{response.data}</li>);
        statsItems2[key] = response.data;
      }
    });

    setIsLoading(false);
  };

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
  };

  useEffect(()=>{
    console.log(props)
  },[])
  function formatStats(input) {
    // Destructure the input object for easier access to its properties
    const {
      currentBalance,
      amountAtRisk,
      availBalance,
      bonusPoints,
      lifeTimeFreePlays,
      lifeTimeBonus,
      lifeTimeFees,
      lifeTimeWin,
      lifeTimeLose,
      lifeTimeNetCasino,
      lifeTimeNetHorses,
      thisWeekSports,
      thisWeekCasino,
      thisWeekHorses,
      lastWeekSports,
      lastWeekCasino,
      lastWeekHorses,
      accountOpened,
      lastCall,
      lastWager,
    } = input;

    // Calculate the Lifetime Net and Total for the last and this week
    const lifeTimeNet = lifeTimeWin + lifeTimeLose;
    const lastWeekTotal = lastWeekSports + lastWeekCasino + lastWeekHorses;
    const thisWeekTotal = thisWeekSports + thisWeekCasino + thisWeekHorses; // Assuming thisWeekCasino and thisWeekHorses are both 0

    // Format dates into a more readable format if necessary
    const formatDate = (dateString) =>
      dateString ? new Date(dateString).toLocaleString() : "";

    const formatDate2 = (dateString) =>
      dateString ? dateString.split("T")[0].split("-").reverse().join("/") : "";

    // Return the new object with keys as displayed in the image
    // TODO-Gabo: Missing
    // FreePlay
    // AvailBalance should add the credit limit

    const nowEST = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));

    return {
      "Current Balance": formatNumber(currentBalance),
      "Amount At Risk": formatNumber(amountAtRisk),
      "Available Balance": formatNumber((currentBalance + (props.Player?.creditLimit ?? 0) + (new Date(props.Player?.tempCreditExpire) > nowEST ? Number(props.Player?.tempCredit ?? 0) : 0))- amountAtRisk),
      "Bonus Points": formatNumber(bonusPoints),
      "Free Play": formatNumber(props.Player.freePlayAmount),
      " ": "",
      "Lifetime Free Plays": formatNumber(lifeTimeFreePlays),
      "Lifetime Bonus": formatNumber(lifeTimeBonus),
      "Lifetime Fees": formatNumber(lifeTimeFees),
      Sports: "",
      "- LifeTime Win": formatNumber(lifeTimeWin),
      "- LifeTime Lose": formatNumber(lifeTimeLose),
      "- LifeTime Net": formatNumber(lifeTimeNet),
      "Lifetime Net Casino": formatNumber(lifeTimeNetCasino),
      "Horses Lifetime Net": formatNumber(lifeTimeNetHorses),
      "Lifetime Total": formatNumber(lifeTimeNet + lifeTimeNetCasino + lifeTimeNetHorses),
      "  ": "",
      "Account Opened": formatDate(accountOpened),
      "Last Call": formatDate2(lastCall),
      "Last Wager": formatDate2(lastWager),
      "   ": "",
      "Last Week Sports": formatNumber(lastWeekSports),
      "Last Week Casino": formatNumber(lastWeekCasino),
      "Last Week Horses": formatNumber(lastWeekHorses),
      "Last Week Total": formatNumber(lastWeekTotal),
      "    ": "",
      "This Week Sports": formatNumber(thisWeekSports),
      "This Week Casino": formatNumber(thisWeekCasino),
      "This Week Horses": formatNumber(thisWeekHorses),
      "This Week Total": formatNumber(thisWeekTotal),
    };
  }

  const formatNumber = (num) => {
    if (num == null || isNaN(num)) return "0";
    const roundedNum = Math.round(num);
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(roundedNum);
  };

  const playerInfo = () =>
    Object.entries(formatStats(playerStatistic)).map(([key, value]) => ({
      key,
      value,
    }));

  const statFormater = (cell, row) => {
    return <span className="text-sm font-semibold">{cell}</span>;
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <BootstrapTable
        className="w-80 min-w-min hidden-header statis"
        data={playerInfo()}
        options={options}
        responsive={false}
        containerStyle={{ height: '430px', overflowY: 'auto', overflowX: 'hidden' }}
      >
        <TableHeaderColumn
          isKey={true}
          dataField="key"
          dataFormat={statFormater}
        >
          Statistics
        </TableHeaderColumn>
        <TableHeaderColumn dataField="value" width="150"></TableHeaderColumn>
      </BootstrapTable>
    </div>
  );
}
